import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Folder, Radio, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

const brDate = (s) => {
  if (!s) return "";
  try { return new Date(s).toLocaleDateString("pt-BR"); } catch { return ""; }
};

export default function ProcessosSidebar() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => {
      api.get("/hermes/recent-processes", { params: { limit: 8 } })
        .then(r => setRows(r.data.rows || []))
        .catch(() => setRows([]))
        .finally(() => setLoading(false));
    };
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="mt-6 pt-4 border-t border-slate-100" data-testid="processos-sidebar">
      <div className="flex items-center gap-2 px-3 py-1.5">
        <Folder className="w-3.5 h-3.5 text-slate-500"/>
        <span className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
          Processos recentes
        </span>
      </div>

      {loading && (
        <div className="px-3 py-2 text-xs text-slate-400">Carregando…</div>
      )}
      {!loading && rows.length === 0 && (
        <div className="px-3 py-2 text-xs text-slate-400 italic">
          Nenhum processo com atividade
        </div>
      )}

      <ul className="mt-1 space-y-0.5">
        {rows.map(r => (
          <li key={r.cnj}>
            <Link
              to={`/processos/${encodeURIComponent(r.cnj)}`}
              className="group flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-slate-50 transition"
              data-testid={`processo-sidebar-${r.cnj}`}
            >
              <div className="flex-1 min-w-0">
                <div className="text-xs font-mono text-slate-800 truncate">
                  {r.cnj}
                </div>
                {r.linked_client_name && (
                  <div className="text-[10px] text-slate-500 truncate">
                    {r.linked_client_name}
                  </div>
                )}
              </div>
              {r.unread > 0 && (
                <span
                  className="text-[10px] font-bold bg-rose-600 text-white rounded-full min-w-[18px] h-[18px] px-1 grid place-items-center"
                  title={`${r.unread} publicação(ões) não lida(s)`}
                >
                  {r.unread}
                </span>
              )}
              <ChevronRight className="w-3.5 h-3.5 text-slate-300 group-hover:text-slate-500"/>
            </Link>
          </li>
        ))}
      </ul>

      {rows.length > 0 && (
        <Link to="/prazos/kanban"
          className="mt-2 mx-3 flex items-center gap-1 text-[10px] text-rose-700 hover:text-rose-900">
          <Radio className="w-3 h-3"/> Ver Prazos Hermes →
        </Link>
      )}
    </div>
  );
}
